<template>
  <a-timeline v-bind="attrs" :class="bem.b()" :pending="pending">
    <template
      v-for="item in Object.keys($slots).filter((slot) => slot !== 'pending')"
      #[item]="data"
    >
      <slot :name="item" v-bind="data || {}"></slot>
    </template>

    <template #pending>
      <slot name="pending"></slot>
    </template>
  </a-timeline>
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { useAttrs } from 'vue'
import { timelineProps } from './timeline'

defineOptions({ name: 'LlTimeline' })

const attrs = useAttrs()
const bem = createNamespace('timeline')

defineProps(timelineProps)
</script>
